import { Link } from 'react-router-dom';

/**
 * Privatumo pranešimas (draft — legal review pending before public go-live).
 * Outcome language only: no vendors, no infrastructure names. The detailed
 * processor list lives in the shop's legal texts (integravizija.lt), not here.
 */
export default function Privatumas() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-xl border border-gray-200 p-8 space-y-5">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Privatumo pranešimas</h1>
          <Link to="/" className="text-sm text-primary-600 hover:text-primary-800">← A5Suite</Link>
        </div>

        <section className="space-y-2 text-sm text-gray-700 leading-relaxed">
          <p>
            <strong>Duomenų valdytojas:</strong> MB „Integra vizija“ (306998587),
            V. Krėvės pr. 80B-37, LT-50385 Kaunas. Kontaktas informacijai apie duomenis:
            info@integravizija.lt.
          </p>
          <p>
            <strong>Kokie duomenys apdorojami:</strong> jūsų įmonės apskaitos duomenys
            (sąskaitos faktūros, žurnalo įrašai, banko operacijos, kontaktai), kuriuos
            pateikiate naudodamiesi A5Suite. Duomenys saugomi Europos Sąjungoje.
          </p>
          <p>
            <strong>Direktyvinės el. pašto ir dokumentų atpažinimo paslaugos:</strong>
            kai naudojate dokumentų atpažinimą ar pokalbį, dalis tekstinės
            informacijos apdorojama išorinėje AI paslaugoje Europos Sąjungoje. Ši
            paslauga įjungiama tik gavus atitinkamą darbo srities sutikimą; jos galite
            bet kada atsisakyti.
          </p>
          <p>
            <strong>Kiek laiko:</strong> apskaitos duomenys saugomi teisės aktuose
            nustatytus terminus (apskaitos dokumentams — ne trumpiau kaip 10 metų).
          </p>
          <p>
            <strong>Jūsų teisės:</strong> susipažinti su duomenimis, reikalauti jų
            ištaisymo, susiejimo su sutikimu ar ištrynimo (kai tai nedraudžiama
            apskaitos įstatymų). Prašymus siųskite info@integravizija.lt.
          </p>
          <p className="text-xs text-gray-400">
            Šis pranešimas yra ruošiamas galutiniam tekstui; galiojantys teisiniai
            dokumentai skelbiami integravizija.lt.
          </p>
        </section>

        <div className="text-sm">
          <Link to="/taisykles" className="text-primary-600 hover:text-primary-800">
            Paslaugos taisyklės →
          </Link>
        </div>
      </div>
    </div>
  );
}
